import { getAlgoliaId, getAlgoliaUserToken, getEditorShowcase, getSearchSettings } from '@mode/shared/util-js';

export const ALGOLIA_APP_ID = getAlgoliaId(window.document, true);
export const ALGOLIA_USER_TOKEN = getAlgoliaUserToken(window.document, true);
export const ALGOLIA_SETTINGS_URL = getSearchSettings(window.document, true);
export const ALGOLIA_CACHE_TIMEOUT = 120000;
export const SHOWCASE_TABLE_NAMES = getEditorShowcase(window.document, true);
export const SETTINGS_MAP = {
  'Report-relevance': 'report',
  'Report-last-edited': 'reportLastEdited',
  'Report-alphabetical': 'reportAlphabetical',
  'Report-alphabetical-desc': 'reportAlphabeticalDesc',
  'Definition-relevance': 'definition',
  'Definition-alphabetical': 'definitionAlphabetical',
  'DataSource-relevance': 'dataSource',
  'DataSourceTable-relevance': 'dataSourceTable',
  'Table-relevance': 'table',
  'Table-alphabetical': 'tableAlphabetical',
  'User-relevance': 'user',
  'User-email': 'userEmail',
  'Organization-relevance': 'organization',
  'UserGroup-relevance': 'group',
  'Collection-relevance': 'space',
};
export const ATTR_MAP = {
  table: [
    'objectType',
    'objectID',
    'name',
    'fullName',
    'description',
    'schema',
    'columns',
    'viewCount',
    'createdAt',
    'updatedAt',
    'webPath',
    'showPath',
    'accountUsername',
  ],
  tableAlphabetical: [
    'objectType',
    'objectID',
    'name',
    'fullName',
    'description',
    'schema',
    'columns',
    'viewCount',
    'createdAt',
    'updatedAt',
    'webPath',
    'showPath',
    'accountUsername',
  ],
  user: [
    'objectType',
    'objectID',
    'name',
    'username',
    'viewCount',
    'createdAt',
    'updatedAt',
    'webPath',
    'avatar',
    'email',
    'token',
  ],
  userEmail: [
    'objectType',
    'objectID',
    'name',
    'username',
    'viewCount',
    'createdAt',
    'connection_access',
    'updatedAt',
    'webPath',
    'avatar',
    'email',
    'token',
  ],
  group: [
    'objectType',
    'objectID',
    'name',
    'memberCount',
    'dataSourcesCount',
    'spacesCount',
    'webPath',
    'apiPath',
    'token',
    'groupType',
    'createdAt',
    'updatedAt',
    'connection_access',
    'scimProvisioned',
  ],
  report: [
    'objectType',
    'dataSourceID',
    'token',
    'reportType',
    'name',
    'description',
    'queryKeywords',
    'viewCount',
    'reportAccountUsername',
    'createdAt',
    'updatedAt',
    'webPath',
    'public',
    'id',
  ],
  reportLastEdited: [
    'objectType',
    'dataSourceID',
    'token',
    'reportType',
    'name',
    'description',
    'queryKeywords',
    'viewCount',
    'reportAccountUsername',
    'createdAt',
    'updatedAt',
    'webPath',
    'public',
    'id',
    'tsPublished',
  ],
  dataSourceTable: [
    'objectType',
    'accountID',
    'objectID',
    'dataSourceID',
    'name',
    'fullName',
    'schema',
    'columns',
    'columnNames',
    'dataSourceName',
    'dataSourceAccountUsername',
    'webPath',
    'showPath',
  ],
  organization: [
    'objectType',
    'objectID',
    'name',
    'username',
    'viewCount',
    'createdAt',
    'updatedAt',
    'webPath',
    'avatar',
  ],
  dataSource: [
    'objectType',
    'objectID',
    'name',
    'accountUsername',
    'adapter',
    'createdAt',
    'updatedAt',
    'webPath',
    'dataSourceType',
    'bridged',
    'creatorId',
    'creatorName',
  ],
  definition: [
    'objectType',
    'objectID',
    'name',
    'token',
    'source',
    'description',
    'created_at',
    'updated_at',
    'creatorUsername',
    'webEditPath',
  ],
  definitionAlphabetical: [
    'objectType',
    'objectID',
    'name',
    'token',
    'source',
    'description',
    'created_at',
    'updated_at',
    'creatorUsername',
    'webEditPath',
  ],
  space: [
    'createdAt',
    'createdBy',
    'creatorId',
    'name',
    'objectID',
    'objectType',
    'reportCount',
    'restrictedAt',
    'spacesCount',
    'spaceType',
    'state',
    'token',
    'updatedAt',
  ],
};
